const STF_CONSTANTS = {
  HAND_PICKED: "Handpicked plans for you",
  // Category Tabs Name Starts Here
  PLAN_CATEGORY: "Plans",

  PREPAID_PLAN_CATEGORY: "Prepaid",
  POSTPAID_PLAN_CATEGORY: "Postpaid",
  NUMBER_CATEGORY: "Numbers",
  TOP_UP_NUMBERS: "Top Up Number",
  MBB_PLAN_CATEGORY: "MBB",
  // Category Tabs Ends Here
  PREDEFINED_TYPE: "PlanInformationBanner",
  DEFAULT_BANNER: "RightImageBanner",
  INFORMATION_BANNER: "InformationBanner",
  FULL_IMAGE_BANNER: "FullImageBanner",
  CUSTOMIZED_TYPE: "CustomizedPlanBanner",
  SWIPE_BANNER: "SwipeBanner",
  SINGLE_BANNER: "SingleBanner",
  SLIDER_BANNER: "SliderBanner",
  HORIZONTAL_CARD: "HorizontalCard",
  VERTICAL_CARD: "VerticalCard",
  NUMBER_CARD: "NumberCard",
  ACTIVE_SIM_TAB: 'Activate SIM',
  PREDEFINED_DENOMINATION_TYPE: "PredefinedDenominationCard",
  DATA_TYPE: "Data",
  MINUTE_TYPE: "Minute",
  SMS_TYPE: "Sms",
  DEFAULT_BANNER_COLOR: "#E10A0A",
  NUMBER_TYPE: "NumbersBanner",
  NUMBER_STATUS_PROCEED: "Proceed",
  NUMBER_STATUS_FAILED: "Failed",
  NUMBER_STATUS_DONE: "Done",
  NUMBER_STATUS_INITIATE: "initiate",
  ACTIVATION_STATUS_SUCCESS: "success",
  ACTIVATION_STATUS_FAILED: "Failed",
  KITCODE_LENGTH: {
    "_ksa": 10,
    "_kw_onboard": 15
  },

  ANGHAMI: "Anghami",
  OSN: "OSN",
  STARZPLAY: "StarzPlay",
  Discovery: "Discovery",
  UFC: "Ufc",
  "DATA-SOCIAL": "DATA-SOCIAL",
  CONTENT_SERVICES: [
    "anghami",
    "starzplay",
    "osn",
    "blutv",
    "discovery",
    "ufc",
  ],
  PAYMENT_STEPS: "PaymentPending",
  TOP_UP_PROGRESS_STEPS: [
    {
      stepName: "is_web_category_selected",
      stepVisited: false,
      stepRequired: true,
    },
    {
      stepName: "choose_topup_category",
      stepVisited: false,
      stepRequired: true,
    },
    {
      stepName: "TopNumberAdded",
      stepVisited: false,
      stepRequired: true,
    },
    {
      stepName: "topPaymentDone",
      stepNameOptional: "topPaymentFailed",
      stepVisited: false,
      stepRequired: true,
    },
  ],
  PROGRESS_STEPS: [
    {
      stepName: "is_web_category_selected",
      stepVisited: false,
      stepRequired: true,
    },
    {
      stepName: "PlanSelected",
      stepVisited: false,
      stepRequired: true,
    },
    {
      stepName: "NumberSelected",
      stepNameOptional: "IsMnp",
      stepVisited: false,
      stepRequired: true,
    },
    {
      stepName: "is_eligible",
      stepNameOptional: "IsEligible",
      stepVisited: false,
      stepRequired: true,
    },
    {
      stepName: "IsLoggedInViaEmail",
      stepVisited: false,
      stepRequired: true,
    },
    {
      stepName: "SimAttached",
      stepNameOptional: "choose_need_sim",
      stepVisited: false,
      stepRequired: true,
    },
    {
      stepName: "PaymentPending",
      stepVisited: false,
      stepRequired: true,
    },
    {
      stepName: "SIMActivated",
      stepNameOptional: "ActivationFailed",
      stepVisited: false,
      stepRequired: true,
    },
  ],
  CTA_BRING_YOUR_NUMBER: "mnp_tap",
  CTA_GENERATE_NOW: "random_tap",
  CTA_I_WANT_THIS_NUMBER: "number_tap",
  CTA_VIEW_ALL: "number_search_tap",
  CTA_CUSTOMIZE_PLAN: "customize_plan_tap",
  CTA_CUSTOMIZE_POSTPAID_PLAN: "customize_post_paid_plan_tap",
  CTA_PLAN_CARD_TAP: "plans_card_tap",
  CTA_PLAN_LIST_TAP: "plans_list_tap",
  CTA_PLAN_SELECTION_TAP: "plans_selection_tap",
  CTA_INFORMATION_BANNER: "information_banner",
  CTA_INFORMATION_BANNER_CTA: "information_banner_cta",
  CTA_ACTIVATE_SIM:"activate_sim_tap",
  CTA_QUICK_TOP_UP: "quick_topup_tap",
  VERSION: "KW",
  VALIDITY_TYPE: ["RenewableBundle", "PAYG"],
  IS_OPTIMA: "optima_enabled"
};

export default STF_CONSTANTS;
